import { Component, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { Notification } from 'src/app/models/NotificationModel';
import { DataTableComponent } from 'src/app/shared/tile-data-table/tile-data-table.component';
import { PlatformApiService, ResultFilter, Results } from 'src/app/services/platform-api.service';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'cw-ci-notification-list',
  templateUrl: './notification-list.component.html',
  styleUrls: []
})
export class NotificationListComponent implements OnInit {
  @Output() stateChange: EventEmitter<any> = new EventEmitter();
  @ViewChild(DataTableComponent, { static: true }) notificationDataTable: DataTableComponent;
  notificationList: Results;

  constructor(private _platformApi: PlatformApiService, public dialog: MatDialog) { }

  ngOnInit() {

  }

  isSelectable(item: Notification) {
    return true;
  }

  addNotification(event?) {
    this.stateChange.emit({ state: 'CREATE' });
  }

  editNotification(item: Notification) {
    this.stateChange.emit({ state: 'EDIT', item });
  }

  loadNotifications(filter = new ResultFilter()) {
    this.notificationDataTable.showProcessing();
    const listObservable = this._platformApi.getNotifications(undefined, filter);
    listObservable.subscribe(results => {
      this.notificationList = results;
    })
  }
}
